(function ($) {
	// Defined a variable to track the last scroll position
	let lastScrollTop = 0;
	function initStickySection() {
		if ($('.sticky-section').length) {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const stickyOffset = $('.sticky-section').offset();
			const ssheight = $('.sticky-section').outerHeight();
			const headerHeight = $('.site-header .inner').outerHeight();
			const stickyOffsetTop = (stickyOffset.top - headerHeight);

			if (scrollTop > lastScrollTop) {
				// Visitor is scroll down
				if ($(window).scrollTop() > 160) {
					$('.sticky-section').addClass('sticky-section--hide');
				}
				if ($(window).scrollTop() > stickyOffset.top) {
					$('.sticky-section').addClass('stuck');
					$('.sticky-section').css('min-height', ssheight);
				}
			} else {
				$('.sticky-section').removeClass('sticky-section--hide');

				if ($(window).scrollTop() <= stickyOffsetTop) {
					$('.sticky-section').removeClass('stuck');
					$('.sticky-section').css('min-height', 'auto');
				}
			}
			// Update our scroll position
			lastScrollTop = scrollTop;
		}
	}

	window.addEventListener('scroll', initStickySection);
}(jQuery));
